import { createPersistentStore, initializeStore } from "./persistentStorage";
import persistentConfig from "./persistentConfig.json";

export const usePersistentStore = createPersistentStore(persistentConfig);

export function initStore() {
  const persistentStore = usePersistentStore();
  initializeStore(persistentStore, persistentConfig);
}
